import React, { Component } from 'react';

type WeekdaysProps = {
  classNames: {
    weekday: string;
    weekdays: string;
    weekdaysRow: string;
  };
  firstDayOfWeek: number;
  weekdaysLong?: Array<string>;
  weekdaysShort?: Array<string>;
  showWeekNumbers?: boolean;
  locale: string;
  localeUtils: Record<string, unknown>;
  weekdayElement?:
    | React.ReactElement
    | React.FC<Record<string, unknown>>
    | React.ComponentClass<Record<string, unknown>>;
};

export default class Weekdays extends Component<WeekdaysProps> {
  shouldComponentUpdate(nextProps: WeekdaysProps) {
    return this.props !== nextProps;
  }

  render() {
    const {
      classNames,
      firstDayOfWeek,
      showWeekNumbers,
      weekdaysLong,
      weekdaysShort,
      locale,
      localeUtils,
      weekdayElement,
    } = this.props;
    const days = [];
    for (let i = 0; i < 7; i += 1) {
      const weekday = (i + firstDayOfWeek) % 7;
      const elementProps = {
        key: i,
        className: classNames.weekday,
        weekday,
        weekdaysLong,
        weekdaysShort,
        localeUtils,
        locale,
      };
      const element =
        weekdayElement && React.isValidElement(weekdayElement)
          ? React.cloneElement(weekdayElement, elementProps)
          : weekdayElement
            ? React.createElement(weekdayElement as React.ComponentType<Record<string, unknown>>, elementProps)
            : null;
      days.push(element);
    }

    return (
      <div className={classNames.weekdays} role="rowgroup">
        <div className={classNames.weekdaysRow} role="row">
          {showWeekNumbers && <div className={classNames.weekday} />}
          {days}
        </div>
      </div>
    );
  }
}
